import type { FaireProductEntity } from "../../entity_types/product";

export const p_ca95k6b3gf: FaireProductEntity = {
  token: "p_ca95k6b3gf",
  type: "product",
  name: "Tumbling Blocks, Quilted Blocks",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/aed17f35b40213f1fc79ce2107dced8bc225b93bbc97cb139ce5b80f48443002.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/08c65ba8e7ab67d1212d531e5055c88f3962b61f29a8d8c84abd038666f9f406.jpeg",
    "https://cdn.faire.com/fastly/9f98d7cec9aee09f15c3251c6e85d8b18c840f95f4ec478cb6d8d608d5b3b2dd.jpeg",
    "https://cdn.faire.com/fastly/d663401728041e6e8fd4fc411351076e953b90f89a4136d2fa78e35a4a4aef15.jpeg",
    "https://cdn.faire.com/fastly/f232a1e6483e2156084c7ee59bd47365b979f4fcd88a451325956be67e492b70.jpeg",
    "https://cdn.faire.com/fastly/d2c227e60c72f68f4860763c1b74c2f6d81ec7f99b2d33d04435259f8e799f1c.jpeg",
    "https://cdn.faire.com/fastly/e1f397c44b444b1cd050378c8a2063714601ef1c6f682e10486fad3ae6e58584.jpeg"
  ],
  priceDollars: 16.5,
  description: "Everyone’s favorite party game, now in COLOR! These are blocks you’ll be so thrilled to look at, you won’t even mind that they’re crashing to the ground. Beauty takes chaos – that’s how the saying goes, right?\n\nProduct Details: \nDimensions: 11 in. x 3.375 in. x 3.375 in. \n54 wooden blocks\n\nFeatures:\nClassic stacking and balance gameplay with a colorful, playful twist\nBright blocks designed to add personality to game night\nEncourages strategy, coordination, concentration, and friendly competition\nFun for groups, parties, family game nights, and casual gatherings\nEasy-to-learn gameplay that works for a wide range of ages\nCompact, giftable format with strong visual appeal for retail displays\nA fun conversation piece for game rooms, coffee tables, and entertaining spaces\n\nIdeal For:\nGift shops and lifestyle boutiques\nToy stores and specialty retailers\nGame and hobby shops\nBookstores and novelty gift shops\nParty and entertaining retailers\nFamily-friendly and screen-free gift collections\nRetailers looking for colorful, social, and impulse-friendly games\nBirthday, holiday, housewarming, and hostess gifting",
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:17.903Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
